import { Col, Divider } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import Panel from '../../Panel/Panel';
import MinNavHeader from '../MinNavHeader/MinNavHeader';
import MinNavList from '../MinNavList/MinNavList';
import './MinNavigation.scss';

export interface IMinNavigationProps {
  className?: string | object;
  open: boolean;
  toggleMenu: () => void;
}

function MinNavigation(props: IMinNavigationProps) {
  const { className, open, toggleMenu } = props;
  const classes = classNames('min-navigation', 'no-print', className);

  return (
    <Panel small={true} open={open} className={classes}>
      <Col>
        <MinNavHeader toggleMenu={toggleMenu} />
        <Divider />
        <MinNavList />
      </Col>
    </Panel>
  );
}

export default MinNavigation;
